import { ThemeColorsKeys } from '../../styles/tokens/colors';

export default {
  circleBorderColor: 'brandTwo100',
  circleHoverBorderColor: 'brandTwo100',
  circleHoverBackgroundColor: 'utilityWhite',
  hoverColour: 'brandTwo100',
} as Record<string, ThemeColorsKeys>;
